import React from "react";
import { WeaDialog, WeaLocaleProvider, WeaTab, WeaSelect } from "ecCom";
import { Button } from "antd";
import { observer } from "mobx-react";
import SystemSetTable from "../components/systemSetTable";
const getLabel = WeaLocaleProvider.getLabel;

@observer
class Main extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      height: 490
    };
  }
  componentDidMount() {
    const { systemSetStore } = this.props.systemSetStore;
    systemSetStore.getModuleOptions();
    systemSetStore.getSystemSetTable({ moduleid: "" });
  }

  getBtns = () => {
    const btns = [
      <Button type="primary" onClick={this.doSave}>
        {getLabel(86, "保存")}
      </Button>,
      <Button type="ghost" onClick={this.props.onCancel}>
        {getLabel(201, "取消")}
      </Button>
    ];
    return btns;
  };

  getSelectBtn = () => {
    const { systemSetStore } = this.props.systemSetStore;
    const { moduleOptions } = systemSetStore;
    const btns = [
      <WeaSelect
        options={moduleOptions}
        style={{ width: 100 }}
        fieldshowtypes={3}
        widthMatchOptions={false}
        onChange={this.onChange}
      />
    ];
    return btns;
  };

  doSave = () => {
    const { systemSetStore } = this.props.systemSetStore;
    systemSetStore.saveConfig2DB(this.props.getMsgTypeList);
    this.props.onCancel();
  };

  onChange = (v, showname) => {
    const { systemSetStore } = this.props.systemSetStore;
    systemSetStore.changeModuleValue(v);
  };

  onChangeHeight = h => {
    this.setState({ height: h - 85 });
  };

  render() {
    if (!this.props.systemSetStore) {
      return null;
    }
    const { systemSetStore } = this.props.systemSetStore;
    const { loading } = systemSetStore;
    const { height } = this.state;
    return (
      <div>
        <WeaDialog
          style={{ width: 720, height: 627 }}
          visible={this.props.visible}
          onCancel={this.props.onCancel}
          title={getLabel(21946, "系统提醒设置")}
          loading={loading}
          icon={"icon-coms-currency"}
          onChangeHeight={this.onChangeHeight}
          iconBgcolor="#407008"
          buttons={this.getBtns()}
        >
          <WeaTab buttons={this.getSelectBtn()} />
          <SystemSetTable tableStore={systemSetStore} height={height} />
        </WeaDialog>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/systemSet.js